import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import {
    MerchantOnboarding as INSERT,
} from 'Components/Api/OnlyAPIOnboardingAPI';
import {
    Container,
    Grid,
    Paper,
    TextField,
    FormControlLabel,
    Checkbox,
    Typography,
    Box,
    Card,
    CardContent,
    Button,
    LinearProgress
} from '@material-ui/core';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import Divider from '@material-ui/core/Divider';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import usePosition from 'Components/Posistion';
import { SelectProfile } from 'Components/Api/UsersApi';
import { useHistory } from 'react-router';
import { FetchDetailsForPincode as FETCH_DETAILS_FOR_PINCODE } from 'Components/Api/UsersApi';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from 'Components/SvgButtons/SearchIcon';
const CustomContainer = HOCLoader(Container);

export const OnlyAPIOnboarding = () => {
    const classes = commonStyle();
    const [responseMessage, setResponseMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [isError, setIsError] = useState(false);
    const [sameAsPersonalAddress, setSameAsPersonalAddress] = useState(false);
    const { latitude, longitude, error } = usePosition();
    const history = useHistory();
    // Document Images
    const [documentImages, setDocumentImages] = useState({
        aadhaarCardFront: '',
        aadhaarCardBack: '',
        panCard: '',
        gstDocument: '',
        Selfie: '',
        shopPhoto: '',
        electricityBill: '',
        CancelledCheque: ''
    });

    // Initial Form Values
    const [FormObj, setFormObj] = useState({
        // Personal Details
        FirstName: '',
        MiddleName: '',
        LastName: '',
        Mobile: '',
        Email: '',
        Aadhaar: '',
        Pan: '',

        // Address Details
        Address: '',
        Area: '',
        PinCode: '',
        StateName: '',
        DistrictName: '',
        TalukaName: '',
        VillageName: '',

        // Business Details
        GSTNumber: '',
        ShopAddress: '',
        ShopArea: '',
        ShopPinCode: '',
        ShopStateName: '',
        ShopDistrictName: '',
        ShopTalukaName: '',
        ShopVillageName: '',

        Latitude: latitude,
        Longitude: longitude
    });

    const FormValidationSchema = Yup.object({
        // Personal Details
        FirstName: Yup.string()
            .min(2, 'Must be at least 2 characters')
            .max(50, 'Must be less than 50 characters')
            .required(PLEASE_PROVIDE_VALID + ' first name'),

        LastName: Yup.string()
            .min(2, 'Must be at least 2 characters')
            .max(50, 'Must be less than 50 characters')
            .required(PLEASE_PROVIDE_VALID + ' last name'),

        Mobile: Yup.string()
            .matches(/^[6-9]\d{9}$/, 'Must be a valid 10-digit mobile number')
            .required(PLEASE_PROVIDE_VALID + ' mobile number'),

        Email: Yup.string()
            .email('Must be a valid email')
            .required(PLEASE_PROVIDE_VALID + ' email'),

        Pan: Yup.string()
            .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Must be a valid PAN format')
            .required(PLEASE_PROVIDE_VALID + ' PAN'),

        // Address Details
        Address: Yup.string()
            .required(PLEASE_PROVIDE_VALID + ' address')
            .test(
                'min-50-clean-chars',
                'Address must be at least 50 characters (excluding special characters like , - % etc)',
                value => {
                    if (!value) return false;
                    // Remove special characters (e.g., , - . / etc.)
                    const cleaned = value.replace(/[^\w\s]/gi, '');
                    return cleaned.length >= 50;
                }
            ),

        Area: Yup.string()
            .required(PLEASE_PROVIDE_VALID + ' area'),

        StateName: Yup.string()
            .required(PLEASE_PROVIDE_VALID + ' state name'),

        DistrictName: Yup.string()
            .required(PLEASE_PROVIDE_VALID + ' district name'),

        TalukaName: Yup.string()
            .required(PLEASE_PROVIDE_VALID + ' taluka name'),

        VillageName: Yup.string()
            .required(PLEASE_PROVIDE_VALID + ' village name'),

        PinCode: Yup.string()
            .matches(/^[1-9][0-9]{5}$/, 'Must be a valid 6-digit PIN code')
            .required(PLEASE_PROVIDE_VALID + ' PIN code'),

        // Business Details
        ShopName: Yup.string()
            .required(PLEASE_PROVIDE_VALID + ' shop name'),

        ShopAddress: Yup.string()
            .required(PLEASE_PROVIDE_VALID + ' shop address')
            .test(
                'min-50-clean-chars',
                'Shop Address must be at least 50 characters (excluding special characters like , - % etc)',
                value => {
                    if (!value) return false;
                    // Remove special characters (e.g., , - . / etc.)
                    const cleaned = value.replace(/[^\w\s]/gi, '');
                    return cleaned.length >= 50;
                }
            ),

        ShopArea: Yup.string()
            .required(PLEASE_PROVIDE_VALID + ' shop area'),


        ShopStateName: Yup.string()
            .required(PLEASE_PROVIDE_VALID + ' shop state name'),

        ShopDistrictName: Yup.string()
            .required(PLEASE_PROVIDE_VALID + ' shop district name'),

        ShopTalukaName: Yup.string()
            .required(PLEASE_PROVIDE_VALID + ' shop taluka name'),

        ShopVillageName: Yup.string()
            .required(PLEASE_PROVIDE_VALID + ' shop village name'),

        ShopPinCode: Yup.string()
            .matches(/^[1-9][0-9]{5}$/, 'Must be a valid 6-digit PIN code')
            .required(PLEASE_PROVIDE_VALID + ' shop PIN code'),

    });


    const fetchUserDetails = async () => {

        setLoading(true);

        const Profileresponse = await SelectProfile();

        if (!Profileresponse.isAuthorized) LOGOUT();

        var profileData = JSON.parse(Profileresponse.data);

        const requestObj = JSON.stringify({ Pincode: profileData.PinCode });

        const addressResponse = await FETCH_DETAILS_FOR_PINCODE(requestObj);

        var addressData = JSON.parse(addressResponse.data);

        const nameParts = (profileData.PersonName || '').trim().split(' ');

        let first = '', middle = '', last = '', rest = [];

        if (nameParts.length === 1) {
            [first] = nameParts;
        } else if (nameParts.length === 2) {
            [first, last] = nameParts;
        } else if (nameParts.length >= 3) {
            [first, middle, ...rest] = nameParts;
            last = rest.join(' ');
        }
        setFormObj({
            ...FormObj,
            FirstName: first,
            MiddleName: middle,
            LastName: last,
            Mobile: profileData.MobileNumber ?? '',
            Email: profileData.EmailID ?? '',
            Aadhaar: profileData.AadharNo ?? '',
            Pan: profileData.PANNo ?? '',
            Address: profileData.Address ?? '',
            Area: profileData.City ?? '',
            PinCode: profileData.PinCode ?? '',
            GSTNumber: profileData.GSTNo ?? '',
            ShopAddress: profileData.ShopAddress ?? '',
            ShopArea: profileData.City ?? '',
            ShopPinCode: profileData.PinCode ?? '',
            ShopName: profileData.FirmName ?? '',
            StateName: addressData.State ?? '',
            DistrictName: addressData.District ?? '',
            TalukaName: addressData.TalukaName ?? '',
            VillageName: addressData.VillageName ?? '',
            ShopStateName: addressData.State ?? '',
            ShopDistrictName: addressData.District ?? '',
            ShopTalukaName: addressData.TalukaName ?? '',
            ShopVillageName: addressData.VillageName ?? '',
        });
        setLoading(false);
    };

    function validatePIN(pin) {
        return /^(\d{4}|\d{6})$/.test(pin);
    }
    const fetchAddressDetails = async (values) => {
        if (
            values.PinCode == undefined ||
            values.PinCode == null ||
            values.PinCode.length != 6 ||
            validatePIN(values.PinCode) == false
        ) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage('Please ,Enter valid Pincode number');
            setLoading(false);
            return;
        }
        setLoading(true);
        const requestObj = JSON.stringify({ Pincode: values.PinCode });

        const addressResponse = await FETCH_DETAILS_FOR_PINCODE(requestObj);

        var addressData = JSON.parse(addressResponse.data);
        setFormObj({
            ...FormObj,
            PinCode: values.PinCode,
            StateName: addressData.State ?? '',
            DistrictName: addressData.District ?? '',
            TalukaName: addressData.TalukaName ?? '',
            VillageName: addressData.VillageName ?? '',
            Area: addressData.VillageName ?? '',

            FirstName: values.FirstName,
            MiddleName: values.MiddleName,
            LastName: values.LastName,
            Mobile: values.Mobile,
            Email: values.Email,
            Pan: values.Pan,
            Aadhaar: values.Aadhaar,
            ShopName: values.ShopName,

            // Address
            Address: values.Address,
            PinCode: values.PinCode,
            State: values.StateName,
            District: values.DistrictName,
            Taluka: values.TalukaName,
            Village: values.VillageName,

            // Business Details
            GSTNumber: values.GSTNumber,
            ShopAddress: values.ShopAddress,
            ShopArea: values.ShopArea,
            ShopPinCode: values.ShopPinCode,
            ShopState: values.ShopStateName,
            ShopDistrict: values.ShopDistrictName,
            ShopTaluka: values.ShopTalukaName,
            ShopVillage: values.ShopVillageName,


            AadhaarCardFront: values.aadhaarCardFront,
            AadhaarCardBack: values.aadhaarCardBack,
            PanCard: values.panCard,
            GstDocument: values.gstDocument,
            Selfie: values.Selfie,
            ShopPhoto: values.shopPhoto,
            ElectricityBill: values.electricityBill,
            CancelledCheque: values.CancelledCheque,

            // Location
            Latitude: latitude,
            Longitude: longitude
        });
        setSeverity('success');
        setResponseMessage("Personal address has been fetched successfully.");
        setIsError(true);
        setLoading(false);
    };


    const fetchShopAddressDetails = async (values) => {
        if (
            values.ShopPinCode == undefined ||
            values.ShopPinCode == null ||
            values.ShopPinCode.length != 6 ||
            validatePIN(values.ShopPinCode) == false
        ) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage('Please ,Enter valid Pincode number');
            setLoading(false);
            return;
        }
        setLoading(true);
        const requestObj = JSON.stringify({ Pincode: values.ShopPinCode });

        const addressResponse = await FETCH_DETAILS_FOR_PINCODE(requestObj);

        var addressData = JSON.parse(addressResponse.data);
        setFormObj({
            ...FormObj,
            ShopPinCode: values.ShopPinCode,
            ShopStateName: addressData.State ?? '',
            ShopDistrictName: addressData.District ?? '',
            ShopTalukaName: addressData.TalukaName ?? '',
            ShopVillageName: addressData.VillageName ?? '',
            ShopArea: addressData.VillageName ?? '',

            FirstName: values.FirstName,
            MiddleName: values.MiddleName,
            LastName: values.LastName,
            Mobile: values.Mobile,
            Email: values.Email,
            Pan: values.Pan,
            Aadhaar: values.Aadhaar,
            ShopName: values.ShopName,

            // Address
            Address: values.Address,
            Area: values.Area,
            PinCode: values.PinCode,
            State: values.StateName,
            District: values.DistrictName,
            Taluka: values.TalukaName,
            Village: values.VillageName,

            // Business Details
            GSTNumber: values.GSTNumber,
            ShopAddress: values.ShopAddress,
            ShopPinCode: values.ShopPinCode,
            ShopState: values.ShopStateName,
            ShopDistrict: values.ShopDistrictName,
            ShopTaluka: values.ShopTalukaName,
            ShopVillage: values.ShopVillageName,


            AadhaarCardFront: values.aadhaarCardFront,
            AadhaarCardBack: values.aadhaarCardBack,
            PanCard: values.panCard,
            GstDocument: values.gstDocument,
            Selfie: values.Selfie,
            ShopPhoto: values.shopPhoto,
            ElectricityBill: values.electricityBill,
            CancelledCheque: values.CancelledCheque,

            // Location
            Latitude: latitude,
            Longitude: longitude
        });
        setSeverity('success');
        setResponseMessage("Shop address has been fetched successfully.");
        setIsError(true);
        setLoading(false);
    };

    const handleFileChange = (event, fieldName, setFieldValue) => {
        const file = event.target.files[0];
        if (!file) return;

        const imageURL = URL.createObjectURL(file);

        setDocumentImages(prev => ({
            ...prev,
            [fieldName]: imageURL
        }));

        const reader = new FileReader();
        setFieldValue(`${fieldName}.Name`, file.name);
        setFieldValue(`${fieldName}.Size`, file.size);
        setFieldValue(`${fieldName}.Type`, file.type);

        reader.onload = function (item) {
            setFieldValue(
                `${fieldName}.Data`,
                item.target.result
                    .replace('data:', '')
                    .replace(/^.+,/, '')
            );
        };

        reader.readAsDataURL(file);
    };

    // Copy Personal Address to Shop Address
    const copyPersonalToShopAddress = (values, setFieldValue) => {
        if (!sameAsPersonalAddress) {
            setFieldValue('ShopAddress', values.Address);
            setFieldValue('ShopArea', values.Area);
            setFieldValue('ShopPinCode', values.PinCode);
            setFieldValue('ShopStateName', values.StateName);
            setFieldValue('ShopDistrictName', values.DistrictName);
            setFieldValue('ShopTalukaName', values.TalukaName);
            setFieldValue('ShopVillageName', values.VillageName);
        }
    };

    // Form Submit Handler
    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        setResponseMessage('');
        setIsError(false);
        setLoading(true);
        const request = {
            // Personal Details
            FirstName: values.FirstName,
            MiddleName: values.MiddleName,
            LastName: values.LastName,
            Mobile: values.Mobile,
            Email: values.Email,
            Pan: values.Pan,
            Aadhaar: values.Aadhaar,
            ShopName: values.ShopName,

            // Address
            Address: values.Address,
            Area: values.Area,
            PinCode: values.PinCode,
            State: values.StateName,
            District: values.DistrictName,
            Taluka: values.TalukaName,
            Village: values.VillageName,

            // Business Details
            GSTNumber: values.GSTNumber,
            ShopAddress: values.ShopAddress,
            ShopArea: values.ShopArea,
            ShopPinCode: values.ShopPinCode,
            ShopState: values.ShopStateName,
            ShopDistrict: values.ShopDistrictName,
            ShopTaluka: values.ShopTalukaName,
            ShopVillage: values.ShopVillageName,


            AadhaarCardFront: values.aadhaarCardFront,
            AadhaarCardBack: values.aadhaarCardBack,
            PanCard: values.panCard,
            GstDocument: values.gstDocument,
            Selfie: values.Selfie,
            ShopPhoto: values.shopPhoto,
            ElectricityBill: values.electricityBill,
            CancelledCheque: values.CancelledCheque,

            // Location
            Latitude: latitude,
            Longitude: longitude
        };
        const requestObj = JSON.stringify(request);

        const response = await INSERT(requestObj);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();
        const data = JSON.parse(response.data);
        if (!response.status) {
            setSeverity('error');
            setResponseMessage(data.Message);
            setIsError(true);
            return;
        }
        if (data.Status == "FAILURE") {
            setSeverity('error');
            setResponseMessage(data.Message);
            setIsError(true);
            return;
        }
        setSeverity('success');
        setResponseMessage(data.Message);
        setIsError(true);
        reset();
        history.push('/RetailerDashboard');
    };

    // Reset Form
    const reset = () => {
        setFormObj({
            ...FormObj,
            FirstName: '',
            MiddleName: '',
            LastName: '',
            Mobile: '',
            Email: '',
            Aadhaar: '',
            Pan: '',
            Address: '',
            Area: '',
            PinCode: '',
            GSTNumber: '',
            ShopAddress: '',
            ShopArea: '',
            ShopPinCode: '',
            AccountNumber: '',
            IFSC: '',
            StateName: '',
            DistrictName: '',
            TalukaName: '',
            VillageName: '',
            ShopStateName: '',
            ShopDistrictName: '',
            ShopTalukaName: '',
            ShopVillageName: '',
            ShopName: ''
        });
        setDocumentImages({
            aadhaarCardFront: '',
            aadhaarCardBack: '',
            panCard: '',
            gstDocument: '',
            Selfie: '',
            shopPhoto: '',
            electricityBill: '',
            CancelledCheque: ''
        });
    };

    const DocumentUpload = ({ label, fieldName, required = false, setFieldValue }) => {
        const [loading, setLoading] = useState(false);

        const handleFileInputChange = (e) => {
            setLoading(true);

            // Show loading bar for 2 seconds
            setTimeout(() => {
                handleFileChange(e, fieldName, setFieldValue);
                setLoading(false);
            }, 1000);
        };

        return (
            <Grid item xs={12} sm={6} md={4} lg={4}>
                <Card variant="outlined">
                    <CardContent>
                        <Typography variant="subtitle2" gutterBottom>
                            {label} {required && <span style={{ color: 'red' }}>*</span>}
                        </Typography>

                        <input
                            type="file"
                            accept=".jpg,.jpeg,.png"
                            id={`upload-${fieldName}`}
                            style={{ display: 'none' }}
                            onChange={handleFileInputChange}
                        />

                        <label htmlFor={`upload-${fieldName}`}>
                            <Button variant="contained" color="primary" component="span">
                                Upload Image
                            </Button>
                        </label>

                        {loading && (
                            <Box mt={2}>
                                <LinearProgress />
                            </Box>
                        )}

                        {!loading && documentImages[fieldName] && (
                            <Box mt={2} position="relative">
                                <img
                                    src={documentImages[fieldName]}
                                    alt={label}
                                    style={{
                                        height: 80,
                                        width: '100%',
                                        objectFit: 'cover',
                                        borderRadius: 4,
                                        border: '1px solid #ddd'
                                    }}
                                />
                                <IconButton
                                    size="small"
                                    style={{
                                        position: 'absolute',
                                        top: 5,
                                        right: 5,
                                        backgroundColor: 'white',
                                        color: 'red',
                                        border: '1px solid red'
                                    }}
                                    onClick={() => clearFile(fieldName, setFieldValue)}
                                >
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                            </Box>
                        )}
                    </CardContent>
                </Card>
            </Grid>
        );
    };


    const clearFile = (fieldName, setFieldValue) => {
        setDocumentImages(prev => {
            const updated = { ...prev };
            delete updated[fieldName];
            return updated;
        });

        setFieldValue(`${fieldName}.Name`, '');
        setFieldValue(`${fieldName}.Size`, '');
        setFieldValue(`${fieldName}.Type`, '');
        setFieldValue(`${fieldName}.Data`, '');
    };
    // Main Form Component
    const TransferForm = ({ values, setFieldValue }) => {
        return (
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Paper className={classes.PaperStyle} style={{ padding: '20px' }}>
                        <Form>
                            <Typography variant="h6" gutterBottom style={{ color: '#1976d2', marginBottom: '20px' }}>
                                Personal Details
                            </Typography>

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <MaterialTextField
                                        label="First Name *"
                                        name="FirstName"
                                        placeholder="Enter First Name"
                                        title="First Name"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <MaterialTextField
                                        label="Middle Name(Optional)"
                                        name="MiddleName"
                                        placeholder="Enter Middle Name"
                                        title="Middle Name"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <MaterialTextField
                                        label="Last Name *"
                                        name="LastName"
                                        placeholder="Enter Last Name"
                                        title="Last Name"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <MaterialNumberField
                                        label="Mobile Number *"
                                        name="Mobile"
                                        length="10"
                                        placeholder="Enter Mobile Number"
                                        title="Mobile Number"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <MaterialTextField
                                        label="Email ID *"
                                        name="Email"
                                        placeholder="Enter Email ID"
                                        title="Email"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <MaterialNumberField
                                        label="Aadhaar Number(Optional)"
                                        name="Aadhaar"
                                        length="12"
                                        placeholder="Enter Aadhaar Number"
                                        title="Aadhaar"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <MaterialTextField
                                        label="PAN *"
                                        name="Pan"
                                        length="10"
                                        placeholder="Enter PAN"
                                        title="Pan"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <MaterialTextField
                                        label="GST Number(Optional)"
                                        name="GSTNumber"
                                        length="15"
                                        placeholder="Enter GST Number"
                                        title="GST Number"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <MaterialTextField
                                        label="Shop Name / Company Name *"
                                        name="ShopName"
                                        placeholder="Enter Shop Name / Company Name"
                                        title="Shop Name / Company Name "
                                    />
                                </Grid>
                            </Grid>

                            <Divider style={{ margin: '20px 0' }} />
                            <Typography variant="h6" gutterBottom style={{ color: '#1976d2', marginBottom: '20px' }}>
                                Address Details
                            </Typography>

                            <Grid item xs={12}>
                                <Typography variant="body2" color="textSecondary">
                                    Note: Shop Address must be at least 50 characters
                                </Typography>
                            </Grid>

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <MaterialTextField
                                        label="Address *"
                                        name="Address"
                                        placeholder="Enter Full Address"
                                        title="Address"
                                        multiline
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                    <MaterialNumberField
                                        label="PIN Code *"
                                        name="PinCode"
                                        length="6"
                                        placeholder="Enter PIN Code"
                                        title="PIN Code"
                                    />
                                </Grid>

                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={1}
                                    lg={1}
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        endIcon={<SearchIcon />}
                                        className={
                                            classes.CustomPrimaryButtonStyle
                                        }
                                        onClick={() => {
                                            fetchAddressDetails(
                                                values
                                            );
                                        }}
                                        style={{
                                            height: '100%',
                                            width: '100%'
                                        }}
                                    ></Button>
                                </Grid>

                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <MaterialTextField
                                        label="State Name *"
                                        name="StateName"
                                        placeholder="Enter State Name"
                                        title="State Name"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <MaterialTextField
                                        label="District Name *"
                                        name="DistrictName"
                                        placeholder="Enter District Name"
                                        title="District Name"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <MaterialTextField
                                        label="Taluka Name *"
                                        name="TalukaName"
                                        placeholder="Enter Taluka Name"
                                        title="Taluka Name"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <MaterialTextField
                                        label="Village Name *"
                                        name="VillageName"
                                        placeholder="Enter Village Name"
                                        title="Village Name"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <MaterialTextField
                                        label="Area *"
                                        name="Area"
                                        placeholder="Enter Area"
                                        title="Area"
                                    />
                                </Grid>
                            </Grid>

                            <Divider style={{ margin: '20px 0' }} />

                            <Typography variant="h6" gutterBottom style={{ color: '#1976d2', marginBottom: '20px' }}>
                                Bussiness Details
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={sameAsPersonalAddress}
                                                onChange={(e) => {
                                                    copyPersonalToShopAddress(values, setFieldValue);
                                                    setSameAsPersonalAddress(e.target.checked);
                                                }}
                                                color="primary"
                                            />
                                        }
                                        label="Shop address same as personal address"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="body2" color="textSecondary">
                                        Note: Shop Address must be at least 50 characters
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <MaterialTextField
                                        label="Shop Address *"
                                        name="ShopAddress"
                                        placeholder="Enter Shop Address"
                                        title="Shop Address"
                                        multiline
                                        disabled={sameAsPersonalAddress}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                    <MaterialNumberField
                                        label="Shop PIN Code *"
                                        name="ShopPinCode"
                                        length="6"
                                        placeholder="Enter Shop PIN Code"
                                        title="Shop PIN Code"
                                        disabled={sameAsPersonalAddress}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={1}
                                    lg={1}
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        endIcon={<SearchIcon />}
                                        className={
                                            classes.CustomPrimaryButtonStyle
                                        }
                                        onClick={() => {
                                            fetchShopAddressDetails(
                                                values
                                            );
                                        }}
                                        style={{
                                            height: '100%',
                                            width: '100%'
                                        }}
                                    ></Button>
                                </Grid>

                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <MaterialTextField
                                        label="Shop State Name *"
                                        name="ShopStateName"
                                        placeholder="Enter Shop State Name"
                                        title="Shop State Name"
                                        disabled={sameAsPersonalAddress}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <MaterialTextField
                                        label="Shop District Name *"
                                        name="ShopDistrictName"
                                        placeholder="Enter Shop District Name"
                                        title="Shop District Name"
                                        disabled={sameAsPersonalAddress}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <MaterialTextField
                                        label="Shop Taluka Name *"
                                        name="ShopTalukaName"
                                        placeholder="Enter Shop Taluka Name"
                                        title="Shop Taluka Name"
                                        disabled={sameAsPersonalAddress}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <MaterialTextField
                                        label="Shop Village Name *"
                                        name="ShopVillageName"
                                        placeholder="Enter Shop Village Name"
                                        title="Shop Village Name"
                                        disabled={sameAsPersonalAddress}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <MaterialTextField
                                        label="Shop Area *"
                                        name="ShopArea"
                                        placeholder="Enter Shop Area"
                                        title="Shop Area"
                                        disabled={sameAsPersonalAddress}
                                    />
                                </Grid>
                            </Grid>

                            <Divider style={{ margin: '20px 0' }} />

                            <Typography variant="h6" gutterBottom style={{ color: '#1976d2', marginBottom: '20px' }}>
                                Document Upload
                            </Typography>

                            <Grid container spacing={2}>
                                <DocumentUpload
                                    label="PAN"
                                    fieldName="panCard"
                                    setFieldValue={setFieldValue}
                                    required={true}
                                />

                                <DocumentUpload
                                    label="Selfie"
                                    fieldName="Selfie"
                                    required={true}
                                    setFieldValue={setFieldValue}
                                />
                                <DocumentUpload
                                    label="Photo with Shop"
                                    fieldName="shopPhoto"
                                    required={true}
                                    setFieldValue={setFieldValue}
                                />
                                <DocumentUpload
                                    label="Cancel Cheque"
                                    fieldName="CancelledCheque"
                                    required={true}
                                    setFieldValue={setFieldValue}
                                />
                                <DocumentUpload
                                    label="Aadhaar Card Front"
                                    fieldName="aadhaarCardFront"
                                    setFieldValue={setFieldValue}
                                    required={true}
                                />
                                <DocumentUpload
                                    label="Aadhaar Card Back(Optional)"
                                    fieldName="aadhaarCardBack"
                                    setFieldValue={setFieldValue}
                                />
                                <DocumentUpload
                                    label="GST Certificate(Optional)"
                                    fieldName="gstDocument"
                                    setFieldValue={setFieldValue}
                                />
                                <DocumentUpload
                                    label="Address Proof of Shop / Electricity Bill(Optional)"
                                    fieldName="electricityBill"
                                    setFieldValue={setFieldValue}
                                />
                            </Grid>

                            <Divider style={{ margin: '30px 0 20px 0' }} />

                            <Grid container spacing={2} justifyContent="flex-end">
                                <Grid item xs={12} sm={6} md={2} lg={2}>
                                    <PrimaryButton
                                        type="submit"
                                        title="Submit"
                                        className={classes.CustomPrimaryButtonStyle}
                                        disabled={loading}
                                        fullWidth
                                    >
                                        {loading ? 'Submitting...' : 'Submit Application'}
                                    </PrimaryButton>
                                </Grid>
                                <Grid item xs={12} sm={6} md={2} lg={2}>
                                    <SecondaryButton
                                        variant="contained"
                                        color="secondary"
                                        type="reset"
                                        title="Reset"
                                        onClick={reset}
                                        className={classes.CustomDangerButtonStyle}
                                        fullWidth
                                    >
                                        Reset
                                    </SecondaryButton>
                                </Grid>
                            </Grid>
                        </Form>
                    </Paper>
                </Grid>
            </Grid>
        );
    };
    useEffect(() => {
        fetchUserDetails();
    }, []);

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize
                initialValues={FormObj}
                validationSchema={FormValidationSchema}
                onSubmit={handleSubmit}
            >
                {({ values, setFieldValue }) => (
                    <TransferForm values={values} setFieldValue={setFieldValue} />
                )}
            </Formik>
        </CustomContainer>
    );
};